import React, { useContext, useEffect, useState } from "react";
import { SvgImages } from "../../Utils/LocalImages";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import Image from "../../Components/Reusable/Image";
import { useNavigate } from "react-router-dom";
import RoutesPath from "../../Utils/RoutesPath";
import { handleApiErrors } from "../../Utils/Utils";
import { toast } from "react-toastify";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import SubAdminService from "../../Services/SubAdmin";
import { AuthContext } from "../../Context/authContext";
import ViewModal from "../../Components/modal/ViewModal";

const ViweSubAdmin = () => {
  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [editData, setEditData] = useState({});
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [getStatusChangeData, setStatusChangeData] = useState({});
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showAuthenticationBox, setShowAuthenticationBox] = useState(false)
  const [authenticationKeyDetail, setAuthenticationKeyDetail] = useState({});

  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await SubAdminService.getAllSubAdmins(
        offset,
        limit,
        searchQuery || ""
      );
      setData(response.data);
      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };
  const ChangeStatus = async (id, status) => {

    try {
      await SubAdminService.updateSubAdminStatus(id, status);
      toast.success("Admin Status Updated successfully");
      var updatedData = data;
      updatedData[
        updatedData.findIndex((item) => item.admin_id === id)
      ].is_active = status;
      setEditData(updatedData);
      setShowConfirmationModal(false);
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };


  const deleteSingleSubAdmin = async (id) => {
    try {
      await SubAdminService.deleteSingleSubAdmin([id]);
      toast.success("Admin Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteMultipleSubAdmins = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item.admin_id);
          }
        });
      }
      await SubAdminService.deleteSingleSubAdmin(itemsToDelete);
      toast.success("Admins Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [offset]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (searchQuery != null) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery]);

  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0">SUB ADMIN </h1>
        <div className="d-flex">
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">Sub Admin List</h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <h1 className="black fs-18 fw-600 mb-0">Sub Admin List</h1>

        <div className="table_title">
          <div className="table_headings mt-2">
            <h1 className="black fs-18 fw-600 mb-0">
              <div
                className="table_delete_icon"
                style={{
                  opacity:
                    data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                }}
                onClick={() => {
                  if (!(data.findIndex((item) => item.isChecked) == -1)) {
                    setIsMultipleDelete(true);
                    setShowDeleteModal(true);
                  }
                }}
              >
                <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
              </div>
            </h1>
            <div className="d-flex gap-4 align-items-center Responsivesection ">
              <div className="position-relative ">
                <input
                  type="search"
                  className="search_box search_bar"
                  placeholder="Search sub admin"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                />
                <Image
                  src={SvgImages.search}
                  style={ImageFilters.gray}
                  className="search_icon"
                  alt="Search Icon"
                  height="20px"
                />
              </div>
              <ButtonWithIcon
                text={"Add Sub Admin"}
                icon={SvgImages.plus}
                onClick={() => {
                  navigate(RoutesPath.addsubadmin);
                }}
              />
            </div>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table
              className="table mb-0 mt-3"
              id="dtHorizontalExample"
              cellSpacing="0"
              width="100%"
            >
              <thead>
                <tr className="table_heading">
                  <th scope="col" style={{ width: "5%" }}>
                    <label className="d-flex align-items-center justify-content-center">
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        style={{ height: "16px", aspectRatio: 1 }}
                        checked={
                          data?.length > 0 &&
                          data?.findIndex((item) => !item.isChecked) == -1
                        }
                        onChange={(value) => {
                          var updatedData = data;
                          updatedData.map((element) => {
                            element.isChecked = value.target.checked;
                          });
                          setData([...updatedData]);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Sr No.
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Name
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Email ID
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Google Authentication Key
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Current Status
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg_light">
                {data?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <label className="d-flex align-items-center justify-content-center">
                        <input
                          className="cursor-pointer"
                          type="checkbox"
                          checked={item.isChecked || false}
                          style={{ height: "16px", aspectRatio: 1 }}
                          onChange={(value) => {
                            var updatedData = data;
                            updatedData[index].isChecked =
                              value.target.checked;
                            setData([...updatedData]);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td>{limit * offset + (index + 1)}</td>
                    <td>{item.name}</td>
                    <td>{item.email}</td>
                    <td>
                      <a style={{ textDecoration: 'underline' }}
                        className="cursor-pointer"
                        onClick={() => {
                          setShowAuthenticationBox(true);
                          setAuthenticationKeyDetail(item);
                        }}
                      >View
                      </a>
                    </td>

                    <td>
                      <label
                        className="switch"
                        data-bs-target="#change_status"
                        data-bs-toggle="modal"
                      >
                        <input
                          type="checkbox"
                          checked={item.is_active}
                          onChange={() => {
                            setShowConfirmationModal(true);
                            setStatusChangeData(item);
                          }}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                    <td>
                      <div className="d-flex gap_8">
                        <a
                          onClick={() =>
                            navigate(RoutesPath.addsubadmin, {
                              state: item,
                            })
                          }
                          className="edit_icons cursor-pointer"
                          data-bs-target="#editclass"
                          data-bs-toggle="modal"
                        >
                          <Image
                            src={SvgImages.edit}
                            style={ImageFilters.green}
                            className="add_icons"
                            alt="Edit Icon"
                          />
                        </a>
                        <a
                          className="delete_icons cursor-pointer"
                          onClick={() => {
                            if (user?.role_type == 0) {
                              setDeleteId(item.admin_id);
                              setIsMultipleDelete(false);
                              setShowDeleteModal(true);
                            } else {
                              toast.error("Only Admin Can Delete")
                            }

                          }}
                        >
                          <Image
                            src={SvgImages.deleteIcon}
                            style={ImageFilters.red}
                            data-bs-target="#delete-modal"
                            data-bs-toggle="modal"
                            alt="Delete Icon"
                          />
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>


          </div>
          {generatePaginationFooter(
            availableDataCount,
            limit,
            offset,
            setOffset
          )}
        </div>

      </div>

      <ViewModal
        showModal={showAuthenticationBox}
        setShowModal={setShowAuthenticationBox}
        children={
         <div>
          <div className="fs-20 fw-600 black mb-2 text-center">Your Authentication Key</div>
          <p className="text-center my-2 ">{authenticationKeyDetail.googleAuthSecretKey}</p>
         </div>
        }
      />



      
      {/* Change Class Status Modal */}
      <ConfirmationModal
        showModal={showConfirmationModal}
        setShowModal={setShowConfirmationModal}
        text={"Are you sure want to change the status?"}
        icon={SvgImages.exclamation_mark} // Specify the path to your delete icon
        rightClickAction={() => {
          ChangeStatus(
            getStatusChangeData.admin_id,
            !getStatusChangeData.is_active
          );
        }}
        theme={ConfirmationModalTheme.warning}
      />

      {/* Delete blog category Modal */}


      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete Selected Admins?"
            : "Are you sure want to delete Admin?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete
            ? deleteMultipleSubAdmins()
            : deleteSingleSubAdmin(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />

    </div>
  );
};

export default ViweSubAdmin;
